function normalizeAddress(value) {
    if (value) {
        return value.toLowerCase().replace(/ /g, '');
    }
    return '';
}

export default normalizeAddress;
